import React from 'react';
import { Container, Row, Col, Card, CardBody, CardHeader } from 'reactstrap';
import { Breadcrumbs, H4, H5, Spinner } from '../../../AbstractElements';
import { LoaderStyle } from '../../../Constant';
import { Data } from '../../../Data/Ui-kit/Data';

const SpinnersContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Spinners' parent='Ui Kits' title='Spinners' />
      <Row>
        <Col sn='12'>
          <Card>
            <CardHeader>
              <H5>{LoaderStyle}</H5>
            </CardHeader>
            <CardBody className='row'>
              <Col md='3'>
                <H4 className='sub-title mb-0 text-center'>{'Loader 1'}</H4>
                <div className='loader-box'>
                  <Spinner className='loader-1' />
                </div>
              </Col>
              {Data.map((spinner) => (
                <Col md='3' key={spinner.id}>
                  <H4 className='sub-title mb-0 text-center'>{spinner.heading}</H4>
                  <div className='loader-box'>
                    <Spinner className={spinner.spinnerClass} />
                  </div>
                </Col>
              ))}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default SpinnersContainer;
